// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  // Replace with your Stripe publishable key (pk_test_... or pk_live_...).
  stripePublishableKey: 'pk_live_51HiSUoGozbMWFnurKPHcwbz5TLsIWWXswYOErYJsT8a00KoQK9Vq3ohsgta3NJVTTx7cK9QgjSrzuClSOC78gj7e00XDbc5HSJ',
  mediaUnlockEndpoints: {
    create: 'createMediaUnlockPayment',
    status: 'mediaUnlockStatus',
    mine: 'myUnlockedMedia'
  },
  production: false,
  firebase: {
    apiKey: 'AIzaSyBYq0SfeJtdvK3SZawuFvbQycgWKoc8_R4',
    authDomain: 'lustrous-stack-709.firebaseapp.com',
    projectId: 'lustrous-stack-709',
    storageBucket: 'lustrous-stack-709.appspot.com',
    messagingSenderId: '472904328011',
    appId: '1:472904328011:web:0afdf64f00c9ad2d50bece',
  },
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
